import { createFileRoute } from "@tanstack/react-router";
import { FormRulesTabPanel } from "@/features/form-editor";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/form/rules",
)({
	component: FormRulesTabPanel,
});
